namespace TabAurous.Finance {
    export interface JournalDetailRow {
        TransDetailsId?: number;
        TransId?: number;
        LedgerId?: number;
        PartyType?: string;
        LedgerName?: string;
        Amount?: number;
        ExchangeRateId?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        Mode?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace JournalDetailRow {
        export const idProperty = 'TransDetailsId';
        export const localTextPrefix = 'Finance.JournalDetail';
        export const deletePermission = 'Finance:Journal:Delete';
        export const insertPermission = 'Finance:Journal:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Journal:Edit';

        export declare const enum Fields {
            TransDetailsId = "TransDetailsId",
            TransId = "TransId",
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ExchangeRateId = "ExchangeRateId",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Mode = "Mode",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
